module.exports = __webpack_public_path__ + "static/media/hello.e4c54ade.jpg";